<ng-container class="account-menu">
  <ul
    class="nav__links row no-gutters"
    id="nav-menu"
    [collapse]="isMenuCollapsed()"
    [isAnimated]="true"
  >
    <li class="auto col-md-4">
      <a title="Cotizaciones" [routerLink]="'my-quotes'" (click)="closeMenu()">Cotizaciones</a>
    </li>
    <li class="auto col-md-4">
      <a title="Libreta de direcciones" [routerLink]="'my-account/address-book'" (click)="closeMenu()"
        >Libreta de direcciones</a
      >
    </li>
    <li class="auto col-md-4">
      <a title="Carritos guardados" [routerLink]="{ cxRoute: 'savedCarts' } | cxUrl" (click)="closeMenu()"
        >Carritos guardados</a
      >
    </li>
    <li class="auto col-md-4">
      <a title="Datos personales" routerLink="my-account/update-profile" (click)="closeMenu()">Datos personales</a>
    </li>
    <li class="auto col-md-4">
      <a title="Selecciona una Empresa" [routerLink]="'select-b2bunit'" (click)="closeMenu()"
        >Selecciona una Empresa</a
      >
    </li>
    <li class="auto col-md-4">
      <a title="Historial de pedido" routerLink="my-account/orders" (click)="closeMenu()">Historial de pedido</a>
    </li>  </ul>
</ng-container>
